
'use strict';

import vex from 'vex-js';

const config = {
    clickEvents: 'click touch',
    submitEvents: 'submit',
    closeBtnClass: 'vex-close-btn',
    closeTarget: '.vex-close, .vex-close-btn, .vex-close-link',
    modalContent: '[data-modal="login-modal"]',
    triggerTarget: '.js-login-open',
    returnToParameter: 'return_to',
    openNowClass: '.js-modal-open',
    vexTheme: 'vex-theme-plain no-padding-darker-theme',
    loginFormTarget: 'c-login-panel > form',
    doAndReturn: 'js-login--do-and-return',
    followLink: 'js-login--follow-link'
};

class LoginModal {

    constructor() {
        if (!$(config.triggerTarget).length) {
            return;
        }
        this.prepareDom();
        this.setupClickEvents();
    }

    /**
     * Parses the HTML string representing the modal that's inside the <script> tag to
     * obtain a DOM sub-tree we can manipulate [almost] like the regular DOM.
     */
    prepareDom() {
        let modalContents = $(config.modalContent).html();

        this.loginUrl = '/designspark/login?return_to=';
        this.modalContext = $(modalContents);
    }

    /**
     * Sets up all click events for the Modal component
     */
    setupClickEvents() {
        $(document).on(config.clickEvents, config.triggerTarget, (e) => this.handleOpenModal(e));
    }

    /**
     * Handles trigger for opening the modal
     *
     * @param {event} e
     * @returns {boolean}
     */
    handleOpenModal(e) {
        e.preventDefault();
        e.stopPropagation();

        this.vex = vex.open({
            content: this.modalContext,
            className: config.vexTheme,
            closeClassName: config.closeBtnClass
        });

        $(config.closeTarget, this.vex[0]).on(config.clickEvents, (e) => this.handleCloseDialog(e));

        // The button that was clicked.
        let $target = $(e.target).closest('a');

        // Variables to decide how the form's action must be assembled.
        let afterLoginUrl = $target.attr('href') || ''; // page pointed by the button
        let currentPageRelativeUrl = document.location.pathname || ''; // page where the button is placed
        let followLink = $target.hasClass(config.followLink);
        let doAndReturn = $target.hasClass(config.doAndReturn); // check if an action must be performed after login

        // Find the first tag (any tag) with an ID above $target's position in the DOM.
        // We'll use this ID as our return permalink.
        let anchors = $target.prevAll('[id]');
        if (anchors.length < 1) {
            // Try again, this time consider the parent too.
            anchors = $target.parents('[id]');
        }

        // Find the closest element with a permalink and push the fragment to the URL.
        if (anchors.length > 0) {
            let fragment = '#'.concat(anchors.first().attr('id'));
            // Append the fragment to the action.
            currentPageRelativeUrl = currentPageRelativeUrl.concat(fragment);
        }

        // Decide whether there's an intermediary action to perform, for this to work we'll have to
        // append another ?return_to to the URL so we can finally get back to the original page.
        //
        // Obviously this must necessarily to be an interstitial action, which can be performed simply
        // by requesting the page once via GET.
        if (doAndReturn) {
            // We must perform an action before returning.
            afterLoginUrl = afterLoginUrl.concat('?return_to='.concat(encodeURIComponent(currentPageRelativeUrl)));
        } else if (!followLink) {
            // There's no action to perform nor a link to follow, so we return straight back to the page which initiated the login.
            afterLoginUrl = currentPageRelativeUrl;
        }

        // Rebuild the form's action with the return_to URL and inject back into the form tag.
        $('form', this.modalContext).attr('action', this.loginUrl.concat(encodeURIComponent(afterLoginUrl)));

        // Stop the click.
        return false;
    }

    /**
     * Handler for when close is clicked
     *
     * @param {event} e
     */
    handleCloseDialog(e) {
        e.preventDefault();

        this.closeDialog();
    }

    /**
     * Closes the dialog associated with this instance
     */
    closeDialog() {
        vex.close(this.vex.data().vex.id);
    }
}

$(window).load(function(){
    new LoginModal();
});



// WEBPACK FOOTER //
// ./src/js/components/login-modal.js